import { c as _c } from "react/compiler-runtime";
import styles from "./Timeline.module.scss";
interface Props {
  type: MediaType;
  url: string;
}
export enum MediaType {
  IMAGE,
  VIDEO,
  HTML,
}
export default function TimelineMediaComponent(props) {
  const $ = _c(6);
  if (props.type === MediaType.VIDEO) {
    let t0;
    if ($[0] !== props.url) {
      t0 = <video autoPlay={true} muted={true} controls={true} loop={true} playsInline={true} className={styles.timelineMediaImage} src={props.url} />;
      $[0] = props.url;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (props.type === MediaType.HTML) {
    let t0;
    if ($[2] !== props.url) {
      t0 = <iframe className={styles.timelineMediaImage} src={props.url} />;
      $[2] = props.url;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let t0;
  if ($[4] !== props.url) {
    t0 = <img src={props.url} className={styles.timelineMediaImage} alt={props.url} />;
    $[4] = props.url;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}